import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import './index.css'
import { FRONTEND_ICONS_ARRAY } from "../../assets/Frontend";
import { BACKEND_ARRAY } from '../../assets/Backend';
import { DATABASE_ARRAY } from '../../assets/Databases';
import { OTHER_SKILLS_ARRAY } from '../../assets/Others';
import LogoWrapper from "../logo-wrapper";
function Skill() {
    
    const controls1 = useAnimation();
    const controls2 = useAnimation();
  const controls3 = useAnimation();
  const controls4 = useAnimation();
  const controls5 = useAnimation();
  const controls6 = useAnimation();
  const controls7 = useAnimation();
  const controls8 = useAnimation();
  const controls9 = useAnimation();

const { ref: ref1, inView: inView1 } = useInView({
  threshold: 0.5, // Trigger when section 1 is 50% in view
  rootMargin: "-10% 0% -20% 0%", // Adding a margin of -100px to the top and bottom
});
    const { ref: ref2, inView: inView2 } = useInView({
      threshold: 0.5, // Trigger when section 1 is 50% in view
      rootMargin: "-10% 0% -20% 0%", // Adding a margin of -100px to the top and bottom
    });
    const { ref: ref3, inView: inView3 } = useInView({
      threshold: 0.5, // Trigger when section 1 is 50% in view
      rootMargin: "-10% 0% -20% 0%", // Adding a margin of -100px to the top and bottom
    });
  const { ref: ref4, inView: inView4 } = useInView({
    threshold: 0.5, // Trigger when section 1 is 50% in view
    rootMargin: "-10% 0% -20% 0%", // Adding a margin of -100px to the top and bottom
  });
  const { ref: ref5, inView: inView5 } = useInView({
    threshold: 0.5, // Trigger when section 1 is 50% in view
    rootMargin: "-10% 0% -20% 0%", // Adding a margin of -100px to the top and bottom
  });
  const { ref: ref6, inView: inView6 } = useInView({
    threshold: 0.5, // Trigger when section 1 is 50% in view
    rootMargin: "-10% 0% -20% 0%", // Adding a margin of -100px to the top and bottom
  });
  const { ref: ref7, inView: inView7 } = useInView({
    threshold: 0.5, // Trigger when section 1 is 50% in view
    rootMargin: "-10% 0% -20% 0%", // Adding a margin of -100px to the top and bottom
  });
  const { ref: ref8, inView: inView8 } = useInView({
    threshold: 0.5, // Trigger when section 1 is 50% in view
    rootMargin: "-10% 0% -30% 0%", // Adding a margin of -100px to the top and bottom
  });
  const { ref: ref9, inView: inView9 } = useInView({
    threshold: 0.5, // Trigger when section 1 is 50% in view
    rootMargin: "-10% 0% -30% 0%", // Adding a margin of -100px to the top and bottom
  });
  
  
    useEffect(() => {
      if (inView1) {
        controls1.start("visible");
      }
      if (inView2) {
        controls2.start("visible");
      }
      if (inView3) {
        controls3.start("visible");
      }
      if (inView4) {
        controls4.start("visible");
      }
      if (inView5) {
        controls5.start('visible')
      }
      if (!inView1) {
        controls1.start("hidden");
      } if (!inView2) {
        controls2.start("hidden");
      } if (!inView3) {
        controls3.start("hidden");
      } if (!inView4) {
        controls4.start("hidden");
      }
      if (!inView5) { 
        controls5.start('hidden')
      }
    }, [controls1, inView1, controls2, inView2, controls3, inView3, inView4, controls4,inView5,controls5]);
  useEffect(() => {
    if (inView6) {
      controls6.start("visible");
    }
    if (inView7) {
      controls7.start("visible");
    }
    if (inView8) {
      controls8.start("visible");
    }
    if (inView9) {
      controls9.start("visible");
    }

    if (!inView6) {
      controls6.start("hidden");
    }
    if (!inView7) {
      controls7.start("hidden");
    }
    if (!inView8) {
      controls8.start("hidden");
    }
    if (!inView9) {
      controls9.start("hidden");
    }
  }, [controls6, controls7, controls8, controls9, inView6, inView7, inView8, inView9]);
    const skillVariant = {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: {
          duration: 0.3,
          ease: "linear",
        },
      },
    };
    return (
      <div id="Skills"  className="skill-container center-align">
        <motion.span ref={ref1} initial="hidden" animate={controls1} variants={skillVariant}>
          <p className="text-1xl">SKILLS</p>
        </motion.span>
        <motion.span ref={ref2} initial="hidden" animate={controls2} variants={skillVariant}>
          <span
            className="text-5xl"
            style={{
              background: "linear-gradient(253.58deg, #FFE066 1.55%, #FFC300 66.84%)",
              WebkitBackgroundClip: "text", // Chrome, Safari, Opera
              WebkitTextFillColor: "transparent", // Chrome, Safari, Opera
              MozBackgroundClip: "text", // Firefox
              MozTextFillColor: "transparent", // Firefox
              backgroundClip: "text", // Standard (not widely supported yet)
              textFillColor: "transparent", // Standard (not widely supported yet)
            }}
          >
            My Skills
          </span>
        </motion.span>
        <motion.span ref={ref3} initial="hidden" animate={controls3} variants={skillVariant} className="text-2xl" style={{ maxWidth: "70%", display: "block", marginTop: 5, fontWeight: 500, lineHeight: 1.4 }}>
          I bring out best user experience using modern frontend architecture.
        </motion.span>
        <motion.div ref={ref4} initial="hidden" animate={controls4} variants={skillVariant} className="front-label">
          <p>FRONTEND DEVELOPMENT</p>
        </motion.div>

        <motion.span ref={ref5} initial="hidden" animate={controls5} className="frontend-icons" variants={skillVariant}>
          {FRONTEND_ICONS_ARRAY.map((item) => {
            return (
              <LogoWrapper>
                <img src={item} alt="" />
              </LogoWrapper>
            );
          })}
        </motion.span>
        <div style={{ display: "flex", gap: 40, flexWrap: "wrap" }}>
          <div>
            <motion.div ref={ref6} initial="hidden" animate={controls6} variants={skillVariant} className="front-label">
              <p>BACKEND DEVELOPMENT</p>
            </motion.div>

            <motion.span ref={ref7} initial="hidden" animate={controls7} className="frontend-icons" variants={skillVariant}>
              {BACKEND_ARRAY.map((item) => {
                return (
                  <LogoWrapper>
                    <img src={item} alt="" />
                  </LogoWrapper>
                );
              })}
              {DATABASE_ARRAY.map((item) => {
                return (
                  <LogoWrapper>
                    <img src={item} alt="" />
                  </LogoWrapper>
                );
              })}
            </motion.span>
          </div>
          <div>
            <motion.div ref={ref8} initial="hidden" animate={controls8} variants={skillVariant} className="front-label">
              <p>OTHER SKILLS</p>
            </motion.div>

            <motion.span ref={ref9} initial="hidden" animate={controls9} className="frontend-icons" variants={skillVariant}>
              {OTHER_SKILLS_ARRAY.map((item) => {
                return (
                  <LogoWrapper>
                    <img src={item} alt="" />
                  </LogoWrapper>
                );
              })}
              
            </motion.span>
          </div>
        </div>
      </div>
    );
}

export default Skill;
